
import '@/mixins/extendedComponent'

import { assets } from '@/webGL/assets'

export default {

  created () {
    window.addEventListener('resize', this._onResize)
    window.addEventListener('scroll', this._onScroll)
    window.addEventListener('keydown', this._onKeyDown)

    this.$device._onResize()
  },

  mounted () {
    requestAnimationFrame( ()=>{
      assets.load().then(()=>{
        this.$hub.emit('assets:loaded')
      })
    })
  },

  methods: {
    onUpdate () {
      this.$dom3d.update()
    },
    onResize () {
      this.$dom3d.onResize(this.$device.width, this.$device.height)
    },

    _onResize (event) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$device._onResize()
        this.$hub.emit('resize', event)
      }, 200)
    },
    _onScroll (event) {
      this.$device._onScroll()
      this.$hub.emit('scroll', event)
    },
    _onKeyDown (event) {
      this.$hub.emit('keydown', event.keyCode)
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        this.$hub.emit('keydown:escape', event.keyCode)
      }
    }
  }
}
